import LiveBroadcastItem from '@/components/main/MyPlus/LiveBroadcastItem';
import {STARRANK_CONTEXT_MENU} from '@/constants/starrank';
import {BROADCAST_TYPES} from '@/constants';

/**
 * 별별랭킹, 테마 별 랭킹 리스트 컴포넌트
 * @param {Object} props
 * @param {{
 *  rankList: Array,
 *  rankCode: string,
 *  title: string,
 *  detail: string,
 * }} props.broadItemList
 */
const StarRankThemeRankList = ({broadItemList}) => {
  if (broadItemList?.rankList?.length > 0) {
    return (
      <div className='cBox-list' data-broadcast='live'>
        <div className='rank-title'>
          <h3>{broadItemList.title}</h3>
          <span>{broadItemList.detail}</span>
        </div>
        <ul>
          {broadItemList.rankList.map((broadItem, index) => {
            return (
              <li
                data-type='cBox'
                key={`broad-item-${broadItem.broadNo}-${index}`}>
                <LiveBroadcastItem
                  broadcastType={BROADCAST_TYPES.LIVE}
                  location='starrank'
                  broadcastId={broadItem.broadNo}
                  thumbnailUrl={broadItem.snUrl}
                  userId={broadItem.userId}
                  userNickname={broadItem.userNick}
                  viewCount={broadItem.totalViewCnt}
                  liveType={broadItem.broadType}
                  title={broadItem.broadTitle}
                  categoryName={
                    broadItem.categoryTags && broadItem.categoryTags.length > 0
                      ? broadItem.categoryTags[0]
                      : ''
                  }
                  categoryNo={broadItem.broadCateNo}
                  categoryTags={broadItem.categoryTags}
                  // Note. 251223 원빌드 작업의 앱 심사용 선배포에 같이 배포되는 PC 별별랭킹 영역에서 언어 태그가 미노출되도록 설정
                  // langTags={broadItem.langTags}
                  autoHashTags={broadItem.autoHashtags}
                  hashTags={broadItem.hashTags}
                  canResend={Boolean(Number(broadItem.visitBroadType))}
                  allowsAdult={Number(broadItem.broadGrade) === 19}
                  hasPassword={broadItem.isPassword === 'Y'}
                  startDateTime={broadItem.broadStart}
                  hasDrops={Boolean(broadItem.isDrops)}
                  contextMenu={{
                    menuList: STARRANK_CONTEXT_MENU,
                  }}
                  rankIndex={index + 1}
                  log={{
                    data: {
                      path1: 'starrank',
                      path2: 'theme_list',
                      themeCode: broadItemList.rankCode,
                    },
                  }}
                  subscriptionOnly={broadItem.subscriptionOnly}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  } else {
    return <></>;
  }
};

export default StarRankThemeRankList;
